import type { QuizPlayerScore } from '@mentimeter/quiz-types';

export const LEADERBOARD_PREVIEW_RESULT: QuizPlayerScore[] = [
  {
    player: {
      identifier: 'preview-results-player-1',
      name: 'Shammy',
      emojiShortname: ':four_leaf_clover:',
      emojiName: 'Shammy',
      index: 0,
    },
    score: {
      total: {
        totalScore: 500,
        position: 1,
      },
      question: {
        score: 0,
        answer: '',
      },
    },
  },
  {
    player: {
      identifier: 'preview-results-player-2',
      name: 'Ted',
      emojiShortname: ':bear:',
      emojiName: 'Ted',
      index: 2,
    },
    score: {
      total: {
        totalScore: 100,
        position: 3,
      },
      question: {
        score: 50,
        answer: '',
      },
    },
  },
  {
    player: {
      identifier: 'preview-results-player-3',
      name: 'Pingu',
      emojiShortname: ':penguin:',
      emojiName: 'Pingu',
      index: 3,
    },
    score: {
      total: {
        totalScore: 300,
        position: 2,
      },
      question: {
        score: 50,
        answer: '',
      },
    },
  },
];
